import { tryParsingSIWE } from '@exodus/web3-utils';
import assert from 'minimalistic-assert';
export const createSimulateMessage = () => async ({ address, asset, message, url, }) => {
    assert(url instanceof URL, "'url' should be an instance of the URL object.");
    const simulationResult = {
        baseAssetName: asset.baseAssetName,
        action: 'NONE',
    };
    tryParsingSIWE({
        address,
        message,
        simulationResult,
        url,
    });
    return simulationResult;
};
